import React from "react";

import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";

import { UniformPreviewPageProps } from "../../../../pages/uniform-preview/uniform-preview-page";
import { UniformWrapper } from "../../../../uniform/uniform-wrapper";

export const UniformPreviewPageTemplate: React.FC<UniformPreviewPageProps> = ({
    composition,
    isUniformPlayground
}) => {
    return (
        <ContentNotFoundErrorBoundary>
            <UniformWrapper
                composition={composition}
                isUniformPlayground={isUniformPlayground}
            />
        </ContentNotFoundErrorBoundary>
    );
};
